export interface SmsErrorDetails {
    message: string;
    code?: number;
    uncertain: boolean;
}

/** Only display validated response fields; never log request bodies or phone data. */
export function smsErrorDetails(error: unknown, now = Date.now()): SmsErrorDetails {
    const value = error as { code?: string; response?: { data?: { reason?: unknown; code?: unknown }; headers?: Record<string, unknown> } } | null;
    const response = value?.response;
    const reason = response?.data?.reason;
    const code = response?.data?.code;
    const uncertain = !response;
    let message = typeof reason === "string" && reason.trim()
        ? reason.trim()
        : uncertain ? "We couldn't confirm whether the request completed. Check the current state before trying again."
        : "The request could not be completed. Please try again later.";
    const retry = response?.headers?.["retry-after"];
    if (typeof retry === "string" || typeof retry === "number") {
        const seconds = /^\d+$/.test(String(retry)) ? Number(retry) : Math.ceil((Date.parse(String(retry)) - now) / 1000);
        if (Number.isFinite(seconds) && seconds >= 0) {
            const totalMinutes = Math.max(1, Math.ceil(seconds / 60));
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            const parts: string[] = [];
            if (hours) parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
            if (minutes) parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
            const waitMessage = `Try again in ${parts.join(" and ")}.`;
            if (!message.includes(waitMessage)) message += ` ${waitMessage}`;
        }
    }
    return { message, code: typeof code === "number" ? code : undefined, uncertain };
}
